import { render, staticRenderFns } from "./SupaAdvancedSearchBaseHeaderSec.vue?vue&type=template&id=847b533e&scoped=true&"
import script from "./SupaAdvancedSearchBaseHeaderSec.vue?vue&type=script&lang=js&"
export * from "./SupaAdvancedSearchBaseHeaderSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847b533e",
  null
  
)

export default component.exports